module.exports = __webpack_public_path__ + "resources/img/img_hyper_personal_en.6f35d1088af80e7879e3ef8b55a63990.png";